import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Productivity } from '@wilson/api/gateway';
import { TimelineTimeframe } from '@wilson/interfaces';
import { ProductivityDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import {
  ShiftTimelineDataState,
  TimelineDataUtilityState,
} from '@wilson/shift-timeline/state';
import { Observable, map } from 'rxjs';
@Injectable()
export class UsersProductivityDataSourceService extends ProductivityDataSourceService {
  private store = inject(Store);

  override isLoadingUsersProductivityStream(): Observable<boolean> {
    return this.store.select(
      TimelineDataUtilityState.isLoadingUsersProductivity,
    );
  }

  override loadingProductivityUserIdsStream(): Observable<string[]> {
    return this.store.select(
      TimelineDataUtilityState.loadingProductivityUserIds,
    );
  }

  override userProductivityStream(
    userId: string,
  ): Observable<number | undefined> {
    return this.store.select(
      TimelineDataUtilityState.userProductivityPercentageStream(userId),
    );
  }

  override usersProductivities(): Observable<Record<string, Productivity>> {
    return this.store.select(TimelineDataUtilityState.usersProductivities);
  }

  override hasFetchedUsersProductivitySuccessfully(): Observable<boolean> {
    return this.store.select(
      TimelineDataUtilityState.hasFetchedUsersProductivitySuccessfully,
    );
  }

  override averageUsersProductivityPercentage(): Observable<number> {
    return this.store
      .select(TimelineDataUtilityState.usersOverallProductivity)
      .pipe(
        map((overallProductivity) =>
          Math.floor((overallProductivity?.productivityRatio ?? 0) * 100),
        ),
      );
  }

  override visibleDateRange(): Observable<TimelineTimeframe> {
    return this.store.select(ShiftTimelineDataState.visibleDateRange);
  }
}
